import { EstateGuestDto } from "@1games-ru/region-shared/dist/types/estate/estate";
import { useCallback, useEffect, useState } from "react";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider.ts";
import useAppSelector from "@/core/helpers/useAppSelector";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { offerResolverSelector } from "@/domains/offer/slice";

export default function useOfferResolverEstate(isShow: boolean) {
  const [estate, setEstate] = useState<EstateGuestDto | null>(null);
  const [pending, setPending] = useState<boolean>(false);
  const offerResolver = useAppSelector(offerResolverSelector);

  const load = useCallback(async () => {
    if (!offerResolver) {
      return;
    }

    try {
      setEstate(null);
      setPending(true);
      const response = await EstateMpProvider.getGuestInfo(offerResolver.targetId);

      if (response instanceof RpcMpProviderFailedResponse) {
        console.error("Failed to fetch houseBuyInfo", response);
        return;
      }

      setEstate(response.data);
    } catch (error) {
      console.error("HouseBuyinfo fetch error:", error);
    } finally {
      setPending(false);
    }
  }, [offerResolver]);

  useEffect(() => {
    if (isShow) {
      load();
    }
  }, [isShow, load]);

  return {
    estate,
    pending,
  };
}
